import {
  COMMISSIONS_UPDATE_COMMISSION_MONTH_BEGIN,
  COMMISSIONS_UPDATE_COMMISSION_MONTH_SUCCESS,
  COMMISSIONS_UPDATE_COMMISSION_MONTH_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_UPDATE_COMMISSION_MONTH_BEGIN:
      return {
        ...state,
        updateCommissionMonthPending: true
      }
    case COMMISSIONS_UPDATE_COMMISSION_MONTH_SUCCESS:
      return {
        ...state,
        updateCommissionMonthPending: false,
        updateCommissionMonthSuccess: true,
        updateCommissionMonthError: null
      }
    case COMMISSIONS_UPDATE_COMMISSION_MONTH_FAILURE:
      return {
        ...state,
        updateCommissionMonthPending: false,
        updateCommissionMonthError: action.data
      }
    default:
      return state
  }
}
